export const baseHost = 'joinfurther';
export const baseDomain = `${baseHost}.com`;

export const FrontEndSiteUrlToStageMap = {
  dev: `https://dev.${baseDomain}`,
  uat: `https://uat.${baseDomain}`,
  production: `https://www.${baseDomain}`,
  local: `http://localhost:2500`,
  e2e: `http://localhost:2501`,
};

export const FrontEndSiteSubdomainUrlToStageMap = {
  dev: `https://{domain}.dev.${baseDomain}`,
  uat: `https://{domain}.uat.${baseDomain}`,
  production: `https://{domain}.${baseDomain}`,
  local: `http://{domain}.localhost:2500`,
  e2e: `http://{domain}.localhost:2501`,
};
